"use strict";
/**
|--------------------------------------------------
| Validate Forms Functions
|--------------------------------------------------
*/

export const recaptchaData = function (token) {
    if (token) {
        $(".g-recaptcha").each(function () {
            var object = $(this);
            object.parents("form").submit();
        });
    }
};

export const validateFormBootstrap = (formClass) => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    let forms = document.querySelectorAll(formClass)

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
        form.setAttribute('novalidate', "");
        form.addEventListener('submit', function (event) {

            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                const recaptchaElement = form.querySelector('.g-recaptcha');
                if(recaptchaElement){
                    grecaptcha.execute();
                }
            }

            form.classList.add('was-validated');
        }, false);
    });
};

export const initCustomFileInputs = (selector) => {
    let inputs = document.querySelectorAll(selector);

    inputs.forEach((item) => {
        item.addEventListener("change", function () {
            let inputStr;
            if (this.files.length > 1) {
                // multiple files selected
                inputStr = this.getAttribute("data-selected").replace("%s", this.files.length);
            } else if (this.files.length == 1) {
                // one file selected
                inputStr = this.files[0].name;
            } else {
                // empty
                inputStr = this.getAttribute("data-label");
            }

            // write to label mask
            this.previousElementSibling.innerHTML = inputStr;
        });
    });
};